import React from 'react';
import PropTypes from 'prop-types';
import AttachMoney from '@mui/icons-material/AttachMoney';
import './paid-feature.css';

export const isPaidAddOn = (feature) =>
  !!(feature && feature.included_in_base !== true);

const paidBadgeCopy = (t) =>
  t('Features.PaidBadge', {
    defaultValue: 'Paid',
  });

const paidNoteCopy = (t) =>
  t('Features.PaidNote', {
    defaultValue:
      'Requires a paid subscription, speak with an expert to activate',
  });

export const PaidFeatureBadge = ({ t }) => (
  <span className="paid-feature-badge">
    <AttachMoney fontSize="inherit" />
    <span>{paidBadgeCopy(t)}</span>
  </span>
);

PaidFeatureBadge.propTypes = {
  t: PropTypes.func.isRequired,
};

export const PaidFeatureNote = ({ t }) => (
  <div className="paid-feature-note" role="note">
    <span className="paid-feature-note-icon" aria-hidden="true">
      <AttachMoney fontSize="small" />
    </span>
    <div className="paid-feature-note-copy">
      <strong>{paidNoteCopy(t)}</strong>
    </div>
  </div>
);

PaidFeatureNote.propTypes = {
  t: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/features/PaidFeatureMark.js